import styled from '@emotion/styled';


const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const Title = styled.h1`
  font-size: 50px;
  margin-bottom: 8px;
`;

const Paragraph = styled.p`
  max-width: 360px;
  font-size: 18px;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.6);
`;

const OutagePage = () => (
  <Container>
    <div>
      <Title>
        Too many requests
      </Title>
      <Paragraph>
        We received a lot of requests temporarily.
        <br />
        Please try again in a little while.
      </Paragraph>
    </div>
  </Container>
);

export default OutagePage;
